import dayjs from 'dayjs';
import gql from 'graphql-tag';

import { useMetricQueries } from '../../lib/hooks';
import { createBatchedFetcher } from '../../lib/gqlFetcher_myf2b';

const fetcher = createBatchedFetcher();

const QUERY = gql`
	query metrics_aggregatedContentTreeProgressHistogram(
		$entityType: EntityType!,
		$entityId: ID!,
		$curriculumId: String!,
		$path: ContentTreePath!,
		$schoolIds: [ID!],
		$gradeIds: [ID!],
	) {
		metrics(entityId: $entityId, entityType: $entityType) {
			aggregatedContentTreeProgressHistogram(
				curriculumId: $curriculumId
				path: $path
				schoolIds: $schoolIds
				gradeIds: $gradeIds
			) {
				startedCount
				completedCount
				median
				histogram {
					rangeStart
					rangeEnd
					count
				}
			}
		}
	}
`;

const useAggregatedContentTreeProgressHistograms = (entities) => useMetricQueries(
	entities.map(
		([entityType, entityId, curriculumId, path, { schoolIds, gradeIds }]) => ({
			document: QUERY,
			variables: { entityType, entityId, curriculumId, path, schoolIds, gradeIds },
			options: {
				queryKey: ['metrics_aggregatedContentTreeProgressHistogram', entityType, entityId, curriculumId, path, schoolIds, gradeIds],
				transformer: ({ metrics }) => ({
					entityType,
					entityId,
					curriculumId,
					path,
					...metrics.aggregatedContentTreeProgressHistogram,
				}),
			},
		})
	),
	fetcher,
);
export default useAggregatedContentTreeProgressHistograms;
